<template>
  <v-container class="missing-env fill-height" fluid>
    <v-row class="ma-0" justify="center" align="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <v-card class="missing-env__card" elevation="0">
          <div class="missing-env__header">
            <div class="missing-env__icon" aria-hidden="true">
              <v-icon icon="mdi-cog-alert-outline" size="36" />
            </div>
            <div>
              <p class="missing-env__eyebrow">Configuration required</p>
              <h1 class="missing-env__title">Missing Auth0 environment variables</h1>
            </div>
          </div>

          <div class="missing-env__rule" aria-hidden="true"></div>

          <p class="missing-env__description text-body-2 text-medium-emphasis">
            Copy <code>env.example</code> to <code>.env</code> and set the Auth0 values before using the app on
            <code>mp-portal.localhost</code>.
          </p>

          <v-list density="compact" class="missing-env__list">
            <v-list-item v-for="variable in missingVariables" :key="variable" :title="variable" prepend-icon="mdi-alert-circle-outline" />
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
  defineProps<{
    missingVariables: string[];
  }>();
</script>

<style scoped>
  .missing-env {
    --vp-orange: #f88d2a;
    --vp-navy: #2d3e52;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.022);
  }

  .missing-env__card {
    padding: 36px;
    border: 1px solid #e9ecef;
    border-radius: 12px;
  }

  .missing-env__header {
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .missing-env__icon {
    width: 64px;
    height: 64px;
    display: grid;
    place-items: center;
    border: 2px solid var(--vp-orange);
    border-radius: 50%;
    color: var(--vp-orange);
  }

  .missing-env__eyebrow {
    margin: 0 0 4px;
    color: var(--vp-orange);
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .missing-env__title {
    margin: 0;
    color: var(--vp-navy);
    font-size: clamp(24px, 4vw, 34px);
    font-weight: 500;
    line-height: 1.2;
  }

  .missing-env__rule {
    width: 56px;
    height: 3px;
    margin: 28px 0 22px;
    background: var(--vp-orange);
    border-radius: 2px;
  }

  .missing-env__description code {
    padding: 2px 6px;
    border-radius: 4px;
    background: #f0f0f0;
    color: var(--vp-navy);
    font-size: 0.9em;
  }

  .missing-env__list {
    border: 1px solid #e9ecef;
    border-radius: 8px;
  }
</style>
